import { CelverLogo } from "@/components/Header"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { useAppConfig, wordmarkParts } from "@/lib/app-config"
import { useIdentity } from "@/lib/identity"

function MicrosoftLogo() {
  return (
    <svg width="16" height="16" viewBox="0 0 21 21" aria-hidden="true">
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
  )
}

export function LoginScreen() {
  const { signIn } = useIdentity()
  const { title, description } = useAppConfig()
  const [, product] = wordmarkParts(title)

  return (
    <div className="flex flex-1 items-center justify-center p-6">
      <Card className="w-full max-w-sm border-border shadow-card animate-in fade-in slide-in-from-bottom-2 duration-300">
        <CardContent className="flex flex-col items-center gap-5 px-8 py-10 text-center">
          <div className="space-y-2">
            <div className="flex items-center justify-center gap-3">
              <CelverLogo className="h-7" />
              <span className="text-2xl font-bold text-foreground">{product}</span>
            </div>
            <p className="text-sm text-fg3">
              {description || "Sign in with your Microsoft account to search and explore your SharePoint documents."}
            </p>
          </div>
          <Button className="gap-2.5 hover:bg-orange-hover" onClick={signIn}>
            <MicrosoftLogo />
            Sign in with Microsoft
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
